export { EmojiHappy as default } from './EmojiHappy';
